export const CHECKLIST_ITEMS = {
  mecanique: [
    { key: 'service_standard', label: 'Service standard' },
    { key: 'grand_service', label: 'Grand service' },
    { key: 'diagnostic', label: 'Diagnostic' },
    { key: 'changement_roues', label: 'Changement de roues' },
    { key: 'montage_pneus', label: 'Montage pneus' },
    { key: 'controle_expertise', label: 'Contrôle avant expertise' },
    { key: 'preparation_expertise', label: 'Préparation expertise' },
    { key: 'selon_rapport_expertise', label: 'Selon rapport d\'expertise' },
    { key: 'presentation_expertise', label: 'Présentation expertise' },
  ],
  carrosserie: [
    { key: 'tolerie', label: 'Tôlerie' },
    { key: 'peinture', label: 'Peinture' },
    { key: 'remplacement_pare_brise', label: 'Remplacement pare-brise' },
    { key: 'infiltration_eau', label: "Infiltration d'eau" },
  ],
  assurance: [
    { key: 'cas_assurance', label: 'Cas assurance' },
  ],
};

export const STATUS_CONFIG = {
  open: { label: 'Ouverte', color: 'bg-blue-100 text-blue-700' },
  signed: { label: 'Signee', color: 'bg-emerald-100 text-emerald-700' },
  in_progress: { label: 'En cours', color: 'bg-amber-100 text-amber-700' },
  completed: { label: 'Terminée', color: 'bg-slate-100 text-slate-700' },
};

export const SERVICE_PLUS_ITEMS = [
  { id: 'nettoyage_moteur', label: 'Nettoyage moteur', price: 65 },
  { id: 'nettoyage_chassis_moteur', label: 'Nettoyage chassis moteur', price: 140 },
  { id: 'presentation_expertise', label: 'Presentation vehicule expertise', price: 110 },
  { id: 'presentation_remorque', label: 'Presentation remorque', price: 180 },
  { id: 'controle_expertise', label: 'Controle expertise', price: 60 },
  { id: 'preparation_expertise', label: 'Preparation expertise (sans piece)', price: 90 },
  { id: 'forfait_controle_presentation', label: 'Forfait controle + presentation', price: 130 },
  { id: 'lavage_complet', label: 'Lavage complet vehicule', price: 80, description: 'Interieur, exterieur, aspirateur, vitres, retouches, repoliner, secher, brillant pneu' },
  { id: 'service_clim', label: 'Service climatisation', price: 0, description: 'Controle, recharge et desinfection climatisation' },
];

export const SUPPLIERS = [
  { id: 'ESA', label: 'ESA', url: 'https://www.esa.ch', color: 'red', logo: 'https://www.esa.ch/assets/esa/img/logo/logo_de.jpg' },
  { id: 'Jacquet', label: 'Jacquet', url: 'https://www.jacquet-af.ch', color: 'blue', logo: 'https://customer-assets.emergentagent.com/job_0a9ef812-a1a0-475e-80b5-a2cc4054894a/artifacts/2dg7fc4q_image.png' },
  { id: 'EC24', label: 'EC24 / Automotive', url: 'https://tm5.carparts-cat.com/ec24', color: 'amber', logo: 'https://tm5.carparts-cat.com/styles/lkq/images/favicon_ec24.png' },
];

export const LIQUIDES_ITEMS = [
  { key: 'huile_moteur', label: 'Huile moteur' },
  { key: 'refroidissement', label: 'Liquide de refroidissement' },
  { key: 'lave_glace', label: 'Lave-glace' },
  { key: 'liquide_frein', label: 'Liquide de frein' },
  { key: 'direction_assistee', label: 'Direction assistee' },
  { key: 'huile_transmission', label: 'Huile de transmission' },
];

export const LIQUIDE_LEVELS = [
  { value: 'ok', label: 'OK', color: 'bg-emerald-500' },
  { value: 'appoint', label: 'Appoint fait', color: 'bg-blue-500' },
];
